import { capitalize } from '@efdigital/ll-addon-ui/helpers/title-case';

import { WORDS } from './words.ts';

export function randomNumberBetween(min: number, max: number): number {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function generateRandomWords(length: number): string {
  const words = Array.from(
    { length },
    () => WORDS[Math.floor(Math.random() * WORDS.length)]
  ).join(' ');
  return capitalize(words);
}

export function generateRandomParagraphs(length: number): string {
  return Array.from({ length }, () => {
    // Random number of sentences per paragraph (2–5)
    const sentenceCount = randomNumberBetween(2, 5);
    const sentences = Array.from({ length: sentenceCount }, () => {
      const sentence = capitalize(
        generateRandomWords(randomNumberBetween(5, 20))
      );
      return sentence + '.';
    });
    return sentences.join(' ');
  }).join('\n\n');
}

export function randomFromArray<T>(array: T[]): T {
  return array[Math.floor(Math.random() * array.length)]!;
}

export function randomValuesFromArray<T>(
  array: T[],
  min: number,
  max: number
): T[] {
  // Shuffle the array
  const shuffled = [...array].sort(() => 0.5 - Math.random());

  // Generate a random number of values between min and max
  const count = Math.floor(Math.random() * (max - min + 1)) + min;

  // Return the first count values
  return shuffled.slice(0, count);
}

export function randomNumbersThatSumTo(size: number, total: number): number[] {
  // Generate an array of the specified size with random numbers that sum up to the specified total
  if (size === 0) {
    return [];
  }
  if (size === 1) {
    return [total];
  }

  // Generate size - 1 random breakpoints between 0 and total
  const breakpoints: number[] = [];
  for (let i = 0; i < size - 1; i++) {
    breakpoints.push(Math.random() * total);
  }

  // Sort breakpoints
  breakpoints.sort((a, b) => a - b);

  // Calculate differences between consecutive breakpoints
  const result: number[] = [];
  result.push(Math.floor(breakpoints[0]!));
  for (let i = 1; i < breakpoints.length; i++) {
    result.push(Math.floor(breakpoints[i]! - breakpoints[i - 1]!));
  }
  result.push(Math.floor(total - breakpoints[breakpoints.length - 1]!));

  // Adjust for rounding errors to ensure exact sum
  const currentSum = result.reduce((sum, num) => sum + num, 0);
  const difference = total - currentSum;
  if (difference !== 0) {
    // Distribute the difference across random elements
    let remaining = difference;
    while (remaining !== 0) {
      const randomIndex = Math.floor(Math.random() * result.length);
      const adjustment = remaining > 0 ? 1 : -1;
      result[randomIndex] = result[randomIndex]! + adjustment;
      remaining -= adjustment;
    }
  }

  return result;
}
